import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";

// 레이아웃
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import RTLLayout from "layouts/rtl";

// 인증
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const [currentTheme] = useState(theme);

  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <Routes>
          {/* 인증 영역 */}
          <Route path="/auth/*" element={<AuthLayout />} />

          {/* 보호 구역: 토큰 없으면 /auth/sign-in 으로 이동 */}
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/rtl/*" element={<RTLLayout />} />
          </Route>

          {/* 최초 진입: /admin 으로 → 보호 라우트가 로그인으로 보내줌 */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          {/* 나머지 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ChakraProvider>
  );
}
